import initialState from './initialState';

const AuthReducer = (state = initialState.auth, action) => {
    switch (action.type) {
        case 'LOGIN_SUCCESS':
            return action.data;
        case 'LOGOUT_SUCCESS':
            return {
                isLogin: false
            };
        default:
            return state;
    }
};

export default AuthReducer;
